import React from 'react';
import PageHero from '../components/PageHero';
import Contact from '../components/Contact';

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <PageHero
        eyebrow="Contact Us"
        title="Let's Start a"
        accent="Conversation"
        description="Whether you have a project in mind or a question for our team, we would love to hear from you."
      />
      <Contact showHeader={false} />
    </main>
  );
}
